import { auth, getAppCheckToken } from './firebase'

// Backend-URL. Partner-portalen kjører på eget domene og kaller Spelaren-API-et på tvers av origin.
// Sett REACT_APP_API_URL for å peke mot et annet miljø (f.eks. staging eller localhost:8080).
export const API_BASE = process.env.REACT_APP_API_URL || 'https://spelaren.no'

const resolveUrl = (url) => {
  if (url.startsWith('http')) return url
  return `${API_BASE}${url}`
}

export const apiFetch = async (url, options = {}) => {
  const headers = { ...options.headers }

  if (headers['Content-Type'] === undefined && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }
  Object.keys(headers).forEach((key) => {
    if (headers[key] === undefined) delete headers[key]
  })

  let idToken = null
  if (auth?.currentUser) {
    try {
      idToken = await auth.currentUser.getIdToken()
    } catch (error) {
      console.warn('Kunne ikke hente auth-token:', error)
    }
  }
  if (!idToken && typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem('firebaseToken')
    if (stored) idToken = stored
  }
  if (idToken) headers['Authorization'] = `Bearer ${idToken}`

  try {
    const appCheckToken = await getAppCheckToken()
    if (appCheckToken) headers['X-Firebase-AppCheck'] = appCheckToken
  } catch (error) {
    console.warn('Kunne ikke hente App Check-token:', error)
  }

  return fetch(resolveUrl(url), { ...options, headers })
}

export const apiGet = (url, options = {}) => apiFetch(url, { method: 'GET', ...options })

export const apiPost = (url, body, options = {}) =>
  apiFetch(url, { method: 'POST', body: body != null ? JSON.stringify(body) : undefined, ...options })

export const apiPut = (url, body, options = {}) =>
  apiFetch(url, { method: 'PUT', body: JSON.stringify(body), ...options })

export const apiPatch = (url, body, options = {}) =>
  apiFetch(url, { method: 'PATCH', body: JSON.stringify(body), ...options })

export const apiDelete = (url, options = {}) => apiFetch(url, { method: 'DELETE', ...options })
